/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit EnableAction/view.blocks to change it.
import * as fromData from 'Simple/Data'
import React from 'react'
import TysiaButton from 'DesignSystem/TysiaButton/index'
import TysiaButtonText from 'DesignSystem/TysiaButton/TysiaButtonText/index'



/** @type {import('Simple/types.js').View} */
export default function EnableAction({
  children,
  viewPath = "/App/Account/Content/Settings/Content/TreatmentAutomations/AutomationsList/EnableAutomationHub/Empty/EnableAction/Confirmation/Content/EnableAction",
  isSubmitting,
  onSubmit
  
}) {
let automationHubEnabledSubmitData = fromData.useDataSubmit({ viewPath,
context: 'automation_hub_enabled',
})
let automationHubEnabledIsSubmittingData = fromData.useDataIsSubmitting({ viewPath,
context: 'automation_hub_enabled',
})
  return (<React.Fragment
>
<TysiaButton
  viewPath={`${viewPath}/TysiaButton`}
 type="primary"
 data="automation_hub_enabled"
 disabled={automationHubEnabledIsSubmittingData}
 onClick={automationHubEnabledSubmitData}
>
{childProps => (
<TysiaButtonText
{...childProps}
  viewPath={`${viewPath}/TysiaButtonText`}
 text="Enable Automation"
/>
)}
</TysiaButton>
{children}
</React.Fragment>)
}